import { DatePicker } from "@mui/x-date-pickers"
import dayjs, { Dayjs } from "dayjs"
import { FC, useImperativeHandle, useRef, useState } from "react"
import { appConstants } from "src/features/shared-module/constants"

export const DatePickerWrapper: FC<any> = ({
  value,
  onChange,
  showInput = true,
  label = "",
  placeholder = appConstants.dateFormat,
  textFieldProps = {},
  datePickerProps = {},
  placement = "bottom-start",
  ref,
  ...props
}) => {
  const [internalDate, setInternalDate] = useState<Dayjs | null>(
    value ? dayjs(value) : null,
  )
  const [open, setOpen] = useState(false)

  const anchorRef = useRef<HTMLElement>(null)
  const [isExternalAnchor, setIsExternalAnchor] = useState(false)

  useImperativeHandle(ref, () => ({
    openCalendar: (anchorElement: HTMLElement) => {
      if (anchorElement) {
        anchorRef.current = anchorElement
        setIsExternalAnchor(true)
      } else {
        setIsExternalAnchor(false)
      }
      setOpen(true)
    },
    closeCalendar: () => {
      setOpen(false)
    },
    // getSelectedDate: () => internalDate,
    // setDate: (date) => {
    //   if (onChange) {
    //     onChange(date)
    //   }
    //   if (value === undefined) {
    //     setInternalDate(date)
    //   }
    // },
  }))

  const handleDateChange = (newDate: Dayjs) => {
    setInternalDate(newDate)
    if (onChange) {
      const formattedDate = newDate
        ? newDate.format(appConstants.dateFormat)
        : ""
      onChange(formattedDate)
    }
    setOpen(false)
  }

  /* get props */
  const getPopperProps = () => {
    if (isExternalAnchor && anchorRef.current) {
      return {
        anchorEl: anchorRef.current,
        placement: placement,
      }
    }
    return { placement }
  }
  /* get props */

  const onOpen = () => {
    if (showInput) {
      setIsExternalAnchor(false)
      setOpen(true)
    }
  }

  return (
    <DatePicker
      format={appConstants.dateFormat}
      value={internalDate}
      onChange={handleDateChange}
      open={open}
      onClose={() => setOpen(false)}
      slotProps={{
        popper: getPopperProps(),
        openPickerIcon: {
          onClick: onOpen,
        },
        textField: {
          ...textFieldProps,
          onClick: onOpen,
          sx: showInput
            ? {}
            : {
                width: 0,
                height: 0,
                overflow: "hidden",
                position: "absolute",
                opacity: 0,
              },
        },
      }}
      {...datePickerProps}
      {...props}
    />
  )
}

/*  TODO: use with react-hook-form later*/
